import { createSlice } from '@reduxjs/toolkit'

const lostCardSlice = createSlice({
    name: 'lost-card',
    initialState: { error: null, loading: false, success: false },
    reducers: {
        setLoading(state, action) {
            const { payload } = action

            state.loading = payload
        },
        setSuccess(state, action) {
            const { payload } = action

            state.success = payload
        },
        setError(state, action) {
            const { payload } = action

            if (!payload) {
                return { ...state, error: null }
            }

            return { ...state, error: payload }
        },
        lostCard() {},
    },
})

const { actions, reducer } = lostCardSlice

export const { setLoading, setSuccess, setError, lostCard } = actions

export default reducer
